import React from 'react'
import cn from 'classnames'
import styles from './ReadyTo.module.sass'
import Link from 'next/link'

export const ReadyTo = () => {
  return (
    <div className={cn('section-border-top', styles.section)}>
      <div className={cn('container', styles.container)}>
        <div className={styles.top}>
          <div className={cn('stage-small', styles.stage)}>Guide your first team of developers</div>
          <h2 className={cn('h2', styles.title)}>Ready to earn?</h2>
          <div className={styles.info}>
            Join the crew of guardians and earn while building meaningful connections with dev
            teams.
          </div>
        </div>
        <div className={styles.btns}>
          <Link href="/api/auth/signin?callbackUrl=/app/onboarding">
            <a className={cn('button', styles.button)}>Apply now</a>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default ReadyTo
